import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

export const computeAcceptRequalificationContext = ({
  view,
  requestView,
  article,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelations;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  const stepConfig = article.step?.step === 'analysis' ? article.step?.config : undefined;

  const organizationPriceEditable = requestView.organizationPrice.editable;
  const organizationPriceRequired = stepConfig?.requireOrganizationPrice ?? false;

  /**
   * SERVICES
   */
  view.services.choice.shown = false;

  view.services.actions.fields.description.editable = true;
  view.services.actions.fields.brandResponsibility.editable = true;
  view.services.actions.fields.organizationPrice.editable = organizationPriceEditable;
  view.services.actions.fields.organizationPrice.required = organizationPriceRequired;
  view.services.actions.fields.spareParts.organizationPrice.editable = organizationPriceEditable;
  view.services.actions.fields.spareParts.organizationPrice.required = organizationPriceRequired;
  view.services.exchange.organizationPrice.editable = organizationPriceEditable;
  view.services.exchange.organizationPrice.required = organizationPriceRequired;

  view.services.none.shown = false;

  /**
   * DEFECTS
   */
  view.defects.fields.brandResponsibility.toggle.editable = true;
};
